export default "__VITE_ASSET__cf186037__"